import * as React from 'react';
import { Typography, Button, Box, Container, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import Contactform from './Contactform';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Footer from "./Footer";
import '../App.css';


const Imprint = () => {
  return (
    <div className="App">

      <main>

        <Container maxWidth="md" className="container serviceContainer">
          <Typography variant='h1' className='sectionTitle'>Karriere</Typography>

          <Typography variant='body1' className='sectionText'>
          Wir suchen Verstärkung für unser Team! Hier finden Sie Informationen zu den von uns angebotenen offenen Stellen. Wir sind gespannt auf Ihre Bewerbungsunterlagen und freuen uns darauf, Sie kennenzulernen.
          </Typography>

          <Accordion className='AccordionWrapper'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Studentische Mitarbeitende im Notarbüro Holland & Kreußlein Oranienburg
        </AccordionSummary>
        <AccordionDetails className='accordionBody'>
   
        <Typography variant='body1' className='sectionText'>
          Wir, die Notare Holland & Kreußlein, suchen ab sofort studentische Mitarbeitende für unser Büro in Oranienburg.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Sie unterstützen uns bei den praktischen Arbeitsabläufen nach Beurkundung und erhalten einen Einblick in die Arbeitsweise und die Inhalte der notariellen Tätigkeiten. Neben Kopier- und Scanarbeiten betreuen Sie dabei insbesondere auch die Digitale Notarplattform (<a href="https://www.lextorbyte.de/">DiNo</a>) und empfangen und betreuen ankommende Mandanten. Werden Sie Teil eines modernen und serviceorientierten Notarbüros und lernen Sie dabei auch den wohl schönsten juristischen Beruf kennen.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Sie arbeiten gerne im Team, sind zuverlässig und kommunikativ, sorgfältig und gut belastbar. Ein gepflegter Umgang mit Menschen ist für Sie selbstverständlich. Sie arbeiten selbstständig und organisiert.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Wir bieten Ihnen ein sich am TVstud der Berliner Universitäten orientierendes Gehalt. Die Arbeitszeit ist nach Absprache flexibel einteilbar, gerne auch am Nachmittag/Abend. Auch die wöchentlich Stundenanzahl ist frei nach Ihren Wünschen vereinbar.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Weitere Informationen zu den Notaren Holland & Kreußlein finden Sie unter <a href="https://www.holland-kreusslein.de/">www.holland-kreusslein.</a>.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Haben Sie Interesse? Schreiben Sie gerne eine E-Mail an <a href="mailto:holland@holland-kreusslein.de">holland@holland-kreusslein.de</a>.
          </Typography>

        </AccordionDetails>
      </Accordion>

{/* 
        <Typography variant='body1' className='sectionText'>
        Ihre Bewerbung richten Sie bitte per E-Mail an <a href="mailto:info@holland-kreusslein.de">info@holland-kreusslein.de</a> oder auf dem Postweg an das Notarbüro Prenzlauer Straße 11 in 16515 Oranienburg.
          </Typography> */}
        
        </Container>

       <Box className="map" id="map">
                                       <Box className="contactMap">
       
                                           {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}
       
                                           <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                               <img src="Karte-HT.webp" className="contactMapImg" />
                                               <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                           </a>
                                           <Container maxWidth="lg" className="container">
                                               <Typography variant='body1' paragraph className="contactMapAddress">
                                                   Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                               </Typography>
                                           </Container>
                                           
                                       </Box>
                                       {/* <Container maxWidth="lg" id="routelink">
                                           <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                       </Container> */}
       
                                   </Box>



                      <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>


      </main >
      <Footer />
    </div >
  );
}

export default Imprint;